import { render, staticRenderFns } from "./SocietyMatchWizardsStepTwo.vue?vue&type=template&id=1bc42dbd&scoped=true"
import script from "./SocietyMatchWizardsStepTwo.vue?vue&type=script&lang=js"
export * from "./SocietyMatchWizardsStepTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc42dbd",
  null
  
)

export default component.exports